import Pickr from "@simonwep/pickr";
import $ from "jquery";
import * as THREE from "three";
import {
  ChangeGlobalMorph,
  ConvertMorphValue,
  GetGroup,
  GetMesh,
  hideIcon,
  pergola,
  pergolaConst,
  showIcon,
  toggleBackWall,
  triggerIconClick,
  theModel
} from "../../../../../core/3d-configurator";
import {
  removeFromUrlSystemBySide,
  removeFromUrlSystemByType,
} from "../../../../../core/customFunctions/initiSubSystem";
import {
  state, MORPH_DATA, getWidthMorph,
  getLengthMorph,
  getHeightMorph
} from "../../../../../core/settings";
import { louverConfig } from "../../../../../core/Meshconfig"
import {
  deleteActiveClassFromContainerRadioType,
  groups,
  stringPostSize,
  stringRoofType,
  getLouvreTypes,
  louvreTypesOpening
} from "./../../../interface.js";
import "./interfaceGroupInputs.scss";
import { generateRangeHTML } from "../interfaceGroupInputs/range/generateRange.js";
import { hostPublicPath, prod } from "../../../../../productionVars";

export const typesInputs = {
  selectButton: "select",
  range: "button",
  postSize: "post-size",
  colorFrame: "colorFrame",
  colorLouvre: "colorLouvre",
  electronic: "electro",
  subSystem: "system",
  roofForLite: "liteRoof",
  typePergola: "typePergola",
  roofType: "roofTypes",
  louvreType: "louvreTypes"
};


export let stringNameRoofColor = null;
export let stringNameFrameColor = null;

export const typeSubSystem = {
  "Outdoor Blinds": "Outdoor Blinds",
  "Slidetec Glass Doors": "Slidetec Glass Doors",
  "Bi-folding Glass Door": "Bi-folding Glass Door",
  "Fixed Shutters": "Fixed Shutters",
  "Aluminum Sliding Shutters": "Aluminum Sliding Shutters",
  "Bi-Ffolding Shutters": "Bi-Ffolding Shutters",
  "Fixed Slats": "Fixed Slats",
};

export const stringPostType = {
  0: "Standard",
  1: "Square Column",
  2: "Round Column",
};

export function updateTextParam(
  customSetting,
  context,
  electro = false,
  onlyText = false,
  subSystem = false,
  walls = false
) {
  const text = [];

  if (!electro && !subSystem) {
    if (customSetting.backWall) {
      text.push("Back Wall");
    }
    if (
      !customSetting.backWall
    ) {
      text.push("Freestanding");
    }
  }
  if (subSystem) {
    customSetting.subSystem.forEach((option) => text.push(option));
  }
  if (electro) {
    customSetting.electro.forEach((option) => {
      text.push(option);
    });
  }

  let displayText = "";

  if (text.length > 1) {
    displayText = text.join(", ");
    if (displayText.length > 15) {
      displayText = displayText.substring(0, 12) + "...";
    }
  } else {
    displayText = text.length === 1 ? text[0] : "-";
  }
  if (onlyText) {
    return displayText;
  }

  $(context)
    .closest(".interface__group")
    .find(".interface__group__head__param")
    .text(displayText);
}

export function updateMaterialMap(mesh) {
  if (mesh?.material) {
    const isTexture =
      typeof state.colorRoof === "string" &&
      /\.(jpe?g|png|webp)$/i.test(state.colorRoof);

    if (isTexture) {
      const loader = new THREE.TextureLoader();
      loader.load(state.colorRoof, (texture) => {
        mesh.material.map = texture;
        mesh.material.color.set(0xffffff);
        mesh.material.needsUpdate = true;
      });
    } else {
      mesh.material.map = null;
      mesh.material.color.set(state.colorRoof);
      mesh.material.needsUpdate = true;
    }
  }
}

export function applyAllColors() {
  if (!pergola.theModel) return;

  pergola.theModel.traverse((o) => {
    if (!o.isMesh || !o.material) return;

    const mName = o.name;

    if (
      mName.includes("heater") || mName.includes("avatar") ||
      mName.includes("Generic") || mName.includes("fastening") ||
      mName.includes("lighting") || mName.includes("Obj_") ||
      mName.includes("logo") || mName.includes("logoPlane") || mName.includes("light_")
    ) {
      return;
    }

    // mesh name directly + ancestors
    let isLouverMesh = false;
    let isFrameMesh =
      mName.startsWith("post_") ||
      mName.startsWith("frame_") ||
      mName.startsWith("mid_beam_");

    let ancestor = o.parent;
    while (ancestor && !isLouverMesh && !isFrameMesh) {
      const aName = ancestor.name || '';
      if (aName.includes("Slimline") || aName.includes("Alpine") ||
        aName.includes("Suburban") || aName.includes("Translucent")) {
        isLouverMesh = true;
      }
      if (aName.startsWith("post_") || aName.startsWith("frame_") ||
        aName.startsWith("mid_beam_")) {
        isFrameMesh = true;
      }
      ancestor = ancestor.parent;
    }

    if (isLouverMesh && (mName.startsWith("Plane") || mName.startsWith("Cube"))) {
      if (o.material.name === 'white_translucent') {
        o.material.transparent = true;
        o.material.opacity = 0.45;
        o.material.depthWrite = false;
        o.material.needsUpdate = true;
        o.userData.translucent = true;
        return;
      } 
      o.material = o.material.clone();
      o.material.color.set(state.colorRoof);
      o.material.needsUpdate = true;
    } else if (isFrameMesh) {
      o.material = o.material.clone();
      o.material.color.set(state.colorBody);
      o.material.needsUpdate = true;
    }
  });
}

export function resetUIToDefaults() {
  function findGroup(title) {
    return $('.interface__group').filter(function () {
      return $(this).find('.interface__group__head__name').text().trim().toUpperCase() === title;
    });
  }

  // SET UP — reset to Freestanding
  $('#freestanding').addClass('active');
  $('#back').removeClass('active');
  findGroup('SET UP').find('.interface__group__head__param').text('Freestanding');

  // ROOF TYPE — reset to Opening Roof (data-value="0")
  // Must set checked state so the browser knows which radio is selected;
  // otherwise clicking the same option again won't fire the "change" event.
  $('.type_interface_radio-model_item').removeClass('type_interface_radio-model_item--active');
  $('.type_interface_radio-model_item input[data-value="0"]').prop('checked', true)
    .closest('.type_interface_radio-model_item')
    .addClass('type_interface_radio-model_item--active');
  $('.type_interface_radio-model_item input[data-value="1"]').prop('checked', false);
  findGroup('ROOF TYPE').find('.interface__group__head__param').text(stringRoofType[0]);

  // LOUVRE TYPE — rebuild options for opening roof and reset to first
  const louvreGroup = findGroup('LOUVRE TYPE');
  if (louvreGroup.length) {
    louvreGroup.find('.interface__group__head__param').text(louvreTypesOpening[0]);
    const inputsContainer = louvreGroup.find('.interface__group__inputs');
    inputsContainer.empty();
    inputsContainer.append(interfaceGroupInputsComponent(typesInputs.louvreType));
  }

  // ROOF DIMENSIONS — reset sliders to defaults (length=2, width=4, height=2)
  MORPH_DATA.width.min = MORPH_DATA.opening.width.min;
  MORPH_DATA.width.max = MORPH_DATA.opening.width.max;
  MORPH_DATA.length.min = MORPH_DATA.opening.length.min;
  MORPH_DATA.length.max = MORPH_DATA.opening.length.max;
  $('.range').each(function () {
    const label = $(this).find('.range__label').text().trim();
    const $input = $(this).find('.range__input__dimensions');
    if (!$input.length) return;
    if (label === 'Louvre Span (m)') {
      $input.attr('min', MORPH_DATA.opening.length.min).attr('max', MORPH_DATA.opening.length.max).val(2).trigger('input');
    }
    if (label === 'Pivot (m)') {
      $input.attr('min', MORPH_DATA.opening.width.min).attr('max', MORPH_DATA.opening.width.max).val(4).trigger('input');
    }
    if (label === 'Height (m)') {
      $input.val(2).trigger('input');
    }
  });

  // POST SIZE — reset to 100x100 (id="0")
  $('.type_interface_post-size_item').removeClass('type_interface_post-size_item--active');
  $('.type_interface_post-size_item input[id="0"]')
    .closest('.type_interface_post-size_item')
    .addClass('type_interface_post-size_item--active');
  findGroup('POST SIZE').find('.interface__group__head__param').text(stringPostSize[0]);

  // ROOF COLOR — reset color box and param
  findGroup('ROOF COLOR').find('#color-box').css('background-color', '#3A3A3A');
  findGroup('ROOF COLOR').find('.type_interface_colors-buttons_item').removeClass('type_interface_colors-buttons_item--active');
  findGroup('ROOF COLOR').find('.interface__group__head__param').text('#3A3A3A');

  // FRAME COLOR — reset color box and param
  findGroup('FRAME COLOR').find('#color-box').css('background-color', '#3A3A3A');
  findGroup('FRAME COLOR').find('.type_interface_colors-buttons_item').removeClass('type_interface_colors-buttons_item--active');
  findGroup('FRAME COLOR').find('.interface__group__head__param').text('#3A3A3A');

  // SIDE INFILL OPTIONS — reset param (items are cleared by removeAllSubsystems)
  findGroup('SIDE INFILL OPTIONS').find('.interface__group__head__param').text('-');

  // HEATING | LIGHTING — clear active states
  findGroup('HEATING | LIGHTING').find('.type_interface_electronic_item').removeClass('type_interface_electronic_item--active');
  findGroup('HEATING | LIGHTING').find('.type_interface_electronic_option').prop('checked', false);
  findGroup('HEATING | LIGHTING').find('.interface__group__head__param').text('-');
}

export function updateHeaterVisibility(isHeaterOn) {
  const isFixedToHouse = state.backWall;
  const root = pergola.theModel.parent || pergola.theModel;
  const visualHeight = getHeightMorph(state.height) * 3.0;
  const halfLength = state.length / 2;
  const halfWidth = state.width / 2;
  const hasCentralPosts = ((state.roofType === 1) && (state.width >= 5.0 || state.length >= 4.0));


  root.traverse((o) => {
    if (o.name.includes("heater")) {
      o.traverse(child => {
        if (child.isMesh && child.morphTargetDictionary && child.morphTargetInfluences) {
          const widthIdx = child.morphTargetDictionary['width'];
          if (widthIdx !== undefined) child.morphTargetInfluences[widthIdx] = 0;
          const lengthIdx = child.morphTargetDictionary['lenth'];
          if (lengthIdx !== undefined) child.morphTargetInfluences[lengthIdx] = 0;
          const widthWallIdx = child.morphTargetDictionary['width_wall'];
          if (widthWallIdx !== undefined) child.morphTargetInfluences[widthWallIdx] = 0;
          const lengthWallIdx = child.morphTargetDictionary['length_wall'];
          if (lengthWallIdx !== undefined) child.morphTargetInfluences[lengthWallIdx] = 0;
        }
      });
    }
  });

  root.traverse((o) => {
    if (o.name.includes("wall_behind_heater") || o.name.includes("no_wall_heater")) {
      o.visible = false;
      o.traverse(child => { child.visible = false; });
    }
  });

  const clonedHeaters = [];
  root.traverse((o) => {
    if (o.userData && o.userData.clonedHeater) {
      clonedHeaters.push(o);
    }
  });
  clonedHeaters.forEach(h => h.parent.remove(h));

  if (isHeaterOn) {
    const heaterName = isFixedToHouse ? "wall_behind_heater_black" : "no_wall_heater_black";
    const zOffset = heaterName === "wall_behind_heater_black" ? 0.1 : -0.1;

    root.traverse((o) => {
      if (o.name === heaterName && !o.userData.clonedHeater) {
        o.visible = true;
        o.traverse(child => { child.visible = true; });

        if (hasCentralPosts) {
          o.position.y = visualHeight + 0.5;
          o.position.z = -(halfLength - 0.18);
          o.position.x = -(halfWidth / 2 + zOffset);

          const heaterClone = o.clone();
          heaterClone.userData.clonedHeater = true;
          heaterClone.position.y = visualHeight + 0.5;
          heaterClone.position.z = -(halfLength - 0.18);
          heaterClone.position.x = halfWidth / 2 - zOffset;
          heaterClone.visible = true;
          heaterClone.traverse(child => { child.visible = true; });
          o.parent.add(heaterClone);
        } else {
          o.position.y = visualHeight + 0.5;
          o.position.z = -(halfLength + zOffset);
          o.position.x = 0;
        }
      }
    });
  }
}

function updateBackWall() {
  const root = pergola.theModel.parent || pergola.theModel;

  root.traverse((o) => {
    if (o.name === 'wall_back_door' || o.name === 'wall_back_no_door') {
      o.visible = false;
      o.traverse(child => { child.visible = false; });
    }
  });

  if (!state.backWall) return;

  const wallName = state.height >= 2 ? 'wall_back_door' : 'wall_back_no_door';

  const widthMorph = getWidthMorph(state.width);
  const lengthMorph = getLengthMorph(state.length);
  const heightMorph = getHeightMorph(state.height);

  root.traverse((o) => {
    if (o.name === wallName) {
      o.visible = true;
      o.traverse(child => {
        child.visible = true;
        if (child.isMesh && child.morphTargetDictionary && child.morphTargetInfluences) {
          // reset global morphs that ChangeGlobalMorph applied
          const widthIdx = child.morphTargetDictionary['width'];
          if (widthIdx !== undefined) child.morphTargetInfluences[widthIdx] = 0;
          const lengthIdx = child.morphTargetDictionary['lenth'];
          if (lengthIdx !== undefined) child.morphTargetInfluences[lengthIdx] = 0;
          const heightIdx = child.morphTargetDictionary['height'];
          if (heightIdx !== undefined) child.morphTargetInfluences[heightIdx] = 0;

          // Apply wall-specific morphs
          const widthWallIdx = child.morphTargetDictionary['width_wall'];
          if (widthWallIdx !== undefined) child.morphTargetInfluences[widthWallIdx] = widthMorph;

          const lengthWallIdx = child.morphTargetDictionary['length_wall'];
          if (lengthWallIdx !== undefined) child.morphTargetInfluences[lengthWallIdx] = lengthMorph;

          const heightWallIdx = child.morphTargetDictionary['height_wall'];
          if (heightWallIdx !== undefined) child.morphTargetInfluences[heightWallIdx] = heightMorph;
        }
      });
    }
  });
}

window.updateHeaterVisibility = updateHeaterVisibility;
window.updateBackWall = updateBackWall;


export function interfaceGroupInputsComponent(
  type,
  ranges,
  initValue = false,
  title
) {
  switch (type) {
    case typesInputs.roofType:
      const radioRoofTypeContent = $(`
                <form class="type_interface_radio-model">
                  <div class="type_interface_radio-model_item option">
                    <input data-value="0" class="type_interface_radio-model_option type_interface_radio-model_option--shade" 
                        type="radio" id="shade" name="fav_language" value="${stringRoofType[0]}"
                        >
                    <label class="type_interface_radio-model_label" for="shade">${stringRoofType[0]}</label>
                  </div>

                  <div class="type_interface_radio-model_item option">
                    <input data-value="1" class="type_interface_radio-model_option type_interface_radio-model_option--blade" 
                        type="radio" id="blade" name="fav_language" value="${stringRoofType[1]}"
                        >
                    <label class="type_interface_radio-model_label" for="blade">${stringRoofType[1]}</label>
                  </div>
                </form>`);

      const activeRoofTypeClass = "type_interface_radio-model_item--active";

      // //INIT MODEL
      radioRoofTypeContent
        .find('.type_interface_radio-model_item input[type="radio"]')
        .each(function () {
          const radioButton = $(this);
          const type = +$(this).attr("data-value");

          if (state.roofType === type) {
            radioButton
              .closest(".type_interface_radio-model_item")
              .addClass(activeRoofTypeClass);
          }

          setTimeout(() => {
            $("#wood-toggle").show();
            $('.interface__group').each(function () {
              const title = $(this).find('.interface__group__head__name').text();
              if (title === 'FRAME COLOR') {
                $(this).find('.color-bottom').show();
                $(this).find('#color-picker').show();
              }
            });

          }, 1000);
        });

      //#region HANDLE MODEL
      radioRoofTypeContent
        .find('.type_interface_radio-model_item input[type="radio"]')
        .on("change", function () {
          state.roofType = +$(this).attr("data-value");

          const limits = state.roofType === 0
            ? MORPH_DATA.opening
            : MORPH_DATA.retractable;

          state.width = Math.max(limits.width.min, Math.min(limits.width.max, state.width));
          state.length = Math.max(limits.length.min, Math.min(limits.length.max, state.length));


          MORPH_DATA.width.min = limits.width.min;
          MORPH_DATA.width.max = limits.width.max;
          MORPH_DATA.length.min = limits.length.min;
          MORPH_DATA.length.max = limits.length.max;


          $('.range').each(function () {
            const label = $(this).find('.range__label').text().trim();
            const $input = $(this).find('.range__input__dimensions');
            const $min = $(this).find('.range__value--min');
            const $max = $(this).find('.range__value--max');

            if (label === 'Pivot (m)') {
              $input.attr('min', limits.width.min);
              $input.attr('max', limits.width.max);
              $input.val(state.width);
              if ($min.length) $min.text(limits.width.min);
              if ($max.length) $max.text(limits.width.max);
              $input.trigger('input');
            }
            if (label === 'Louvre Span (m)') {
              $input.attr('min', limits.length.min);
              $input.attr('max', limits.length.max);
              $input.val(state.length);
              if ($min.length) $min.text(limits.length.min);
              if ($max.length) $max.text(limits.length.max);
              $input.trigger('input');
            }
          });


          state.louvreType = 0;
          pergola.switchFrame();
          showIcon(10, true);

          $("#wood-toggle").show();
          $('.interface__group').each(function () {
            const title = $(this).find('.interface__group__head__name').text();
            if (title === 'FRAME COLOR') {
              $(this).find('.color-bottom').show();
              $(this).find('#color-picker').show();
            }
          });


          const parentItem = $(this).closest(
            ".type_interface_radio-model_item"
          );

          radioRoofTypeContent
            .find(".type_interface_radio-model_item")
            .removeClass(activeRoofTypeClass);

          parentItem.addClass(activeRoofTypeClass);

          $(parentItem)
            .closest(".interface__group")
            .find(".interface__group__head__param")
            .text($(this).val());


          state.louvreType = 0;

          // rebuild louvre type options
          const louvreGroup = $('.interface__group').filter(function () {
            return $(this).find('.interface__group__head__name').text().trim().toUpperCase() === 'LOUVRE TYPE';
          });

          if (louvreGroup.length) {
            const newLouvreTypes = getLouvreTypes();
            louvreGroup.find('.interface__group__head__param').text(newLouvreTypes[0]);

            const inputsContainer = louvreGroup.find('.interface__group__inputs');
            inputsContainer.empty();
            inputsContainer.append(
              interfaceGroupInputsComponent(typesInputs.louvreType)
            );
          }

          pergola.update();
        });
      //#endregion

      return radioRoofTypeContent;

    case typesInputs.louvreType:
      const louvreTypes = getLouvreTypes();
      const louvreTypeKeys = Object.keys(louvreTypes);

      const radioLouvreTypeContent = $(`
        <form class="type_interface_louvre-type">
          ${louvreTypeKeys.map((key) => `
            <div class="type_interface_louvre-type_item option" data-value="${key}">
              <input class="type_interface_louvre-type_option" 
                  type="radio" id="louvre_${key}" name="louvre_type" value="${louvreTypes[key]}">
              <label for="louvre_${key}">${louvreTypes[key]}</label>
            </div>
          `).join("")}
        </form>
      `);

      const activeLouvreTypeClass = "type_interface_louvre-type_item--active";

      // INIT 
      radioLouvreTypeContent.find('.type_interface_louvre-type_item').each(function () {
        const value = +$(this).attr("data-value");
        if (state.louvreType === value) {
          $(this).addClass(activeLouvreTypeClass);
          $(this).find('input').prop("checked", true);
        }
      });

      // HANDLE — louvre type change
      radioLouvreTypeContent.find('.type_interface_louvre-type_item').on("click", function () {
        state.louvreType = +$(this).attr("data-value");

        radioLouvreTypeContent
          .find(".type_interface_louvre-type_item")
          .removeClass(activeLouvreTypeClass);

        $(this).addClass(activeLouvreTypeClass);

        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text($(this).find('input').val());

        pergola.update();
      });

      return radioLouvreTypeContent;

    case typesInputs.selectButton:
      const selectWalls = $(`
                <form class="type_interface_checkbox-wall type_interface_checkbox-wall--four-season">
                  <div class="wrapp-wall" id="wall-option">
                     <div class="type_interface_checkbox-wall_item option active" id="freestanding"> 
                        <div class="type_interface_checkbox-wall_item-img type_interface_checkbox-wall_item-img--freeStanding"></div>
                        <div class="type_interface_checkbox-wall_bottom">
                          <input class="type_interface_checkbox-wall_option" type="radio" name="mounted_type" value="Freestanding" checked>
                          <label>Freestanding</label>
                        </div> 
                     </div>

                     <div class="type_interface_checkbox-wall_item option" id="back"> 
                        <div class="type_interface_checkbox-wall_item-img type_interface_checkbox-wall_item-img--back"></div>
                        <div class="type_interface_checkbox-wall_bottom">
                          <input class="type_interface_checkbox-wall_option" type="radio" name="mounted_type" value="Fixed to House">
                          <label>Fixed to House</label>
                        </div> 
                     </div>
                  </div>
                </form>
                 `);

      const activeWallClass = "active";
      const freestandingItem = selectWalls.find("#freestanding");
      const backWall = selectWalls.find("#back");

      // INIT
      if (state.backWall) {
        freestandingItem.removeClass(activeWallClass);
        backWall.addClass(activeWallClass);
      }
      toggleBackWall(state.backWall);

      // HANDLE FREESTANDING
      freestandingItem.on("click", function () {
        if (!state.backWall) return;

        state.backWall = false;
        removeFromUrlSystemBySide(pergolaConst.side.Back);

        freestandingItem.addClass(activeWallClass);
        backWall.removeClass(activeWallClass);

        toggleBackWall(state.backWall);
        updateBackWall();
        pergola.update();

        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text("Freestanding");
      });

      backWall.on("click", function () {
        if (state.backWall) return;

        state.backWall = true;

        backWall.addClass(activeWallClass);
        freestandingItem.removeClass(activeWallClass);

        toggleBackWall(state.backWall);
        updateBackWall();
        pergola.update();

        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text("Fixed to House");
      });

      return selectWalls;

    case typesInputs.range:
      let rangesResult = $(``);

      if (ranges.length) {
        ranges.forEach((range) => {
          rangesResult = rangesResult.add(generateRangeHTML(range));
        });
      }

      return rangesResult;

    case typesInputs.postSize:
      const postSizeContent = $(`
              <form class="type_interface_post-size">
                  <div class="type_interface_post-size_item option">
                      <input class="type_interface_post-size_option" type="radio" id="0" name="fav_language" value="${stringPostSize[0]}">
                      <label for="0">100 x 100</label>
                  </div>

                   <div class="type_interface_post-size_item option">
                      <input class="type_interface_post-size_option" type="radio" id="1" name="fav_language" value="${stringPostSize[1]}">
                      <label for="1">150 x 150</label>
                 </div>
              </form>
          `);

      const activeClass = "type_interface_post-size_item--active";

      // //INIT INPUT
      postSizeContent.find(".type_interface_post-size_item").each(function () {
        $(this).removeClass(activeClass);

        if (state.postSize === +$(this).find("input").attr("id")) {
          $(this).addClass(activeClass);
        }
      });

      //HANDLE Change
      postSizeContent
        .find(".type_interface_post-size_item")
        .on("click", function () {
          postSizeContent
            .find(".type_interface_post-size_item")
            .removeClass(activeClass);

          const paramLabel = $(this).find("input").val();
          state.postSize = +$(this).find("input").attr("id");

          $(this).addClass(activeClass);

          const $groupHeadParam = $(this)
            .closest(".interface__group")
            .find(".interface__group__head__param");

          $groupHeadParam.text(paramLabel);

          // Switch post meshes before update
          pergola.switchPostSize();
          pergola.update();
        });

      return postSizeContent;

    case typesInputs.colorFrame:
      const frameColorContent = $(`
    <form class="type_interface_colors-buttons">
      <div class="colors_container">
        <p class="add-info">Select Your Color</p>
        <div class="color-bottom">
          <div class="colors_picker_container">
            <div id="color-box" class="colors_picker_color" style="background-color: ${state.colorBody}"></div>
            <div class="colors_picker_button" id="frame-color-picker-btn">Color Picker</div>
            <div id="frame-color-picker-container"></div>
          </div>
        </div>
      </div>
    </form>
  `);

      const frameActiveColorClass = "type_interface_colors-buttons_item--active";

      // INIT INPUT
      frameColorContent.find('input[type="radio"]').each(function () {
        const backgroundColor = pergola.rgbToHex(
          $(this)
            .closest(".type_interface_colors-buttons_item")
            .find(".image-container")
            .css("background-color")
        );
        const nameOfColor = $(this).val();

        if (state.colorBody === backgroundColor) {
          $(this)
            .closest(".type_interface_colors-buttons_item")
            .addClass(frameActiveColorClass);
          $(this).prop("checked", true);
          stringNameFrameColor = nameOfColor;

          setTimeout(() => {
            $(this)
              .closest(".interface__group")
              .find(".interface__group__head__param")
              .text(`${nameOfColor}`);
          }, 400);
        }
      });

      // HANDLE INPUTS
      frameColorContent.find('input[type="radio"]').on("click", function () {
        const nameOfColor = $(this).val();
        stringNameFrameColor = nameOfColor;

        const backgroundColor = pergola.rgbToHex(
          $(this)
            .closest(".type_interface_colors-buttons_item")
            .find(".image-container")
            .css("background-color")
        );

        state.colorBody = backgroundColor;

        $(this)
          .closest(".type_interface_colors-buttons_item")
          .addClass(frameActiveColorClass);
        $(this)
          .closest(".type_interface_colors-buttons")
          .find(".type_interface_colors-buttons_item")
          .not($(this).closest(".type_interface_colors-buttons_item"))
          .removeClass(frameActiveColorClass);
        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${nameOfColor}`);

        applyAllColors();
        // pergola.updateLogos(state.colorBody);
        pergola.update();
      });

      // HANDLE COLOR PICKER
      let framePickr;
      frameColorContent.find("#frame-color-picker-btn").on("click", function () {
        const $group = $(this).closest(".interface__group");

        if (!framePickr) {
          const container = frameColorContent.find("#frame-color-picker-container")[0];
          if (!container) return;

          framePickr = Pickr.create({
            el: container,
            theme: "classic",
            default: state.colorBody,
            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: { hex: false, rgba: false, input: false },
            },
          });

          framePickr.on("change", (color) => {
            const selectedColor = color.toHEXA().toString().substring(0, 7);
            state.colorBody = selectedColor;
            applyAllColors();

            $group
              .find(".interface__group__head__param")
              .text(`${selectedColor}`);

            frameColorContent
              .find("#color-box")
              .css("background-color", selectedColor);

            deleteActiveClassFromContainerRadioType(
              frameColorContent,
              ".type_interface_colors-buttons_item",
              frameActiveColorClass
            );

            pergola.updateLogos();
            pergola.update();
          });
        }
        framePickr.show();
      });

      return frameColorContent;

    case typesInputs.colorLouvre:
      const louvreColorContent = $(`
    <form class="type_interface_colors-buttons">
      <div class="colors_container">
        <p class="add-info">Select Your Color</p>
        <div class="color-bottom">
          <div class="colors_picker_container">
            <div id="color-box" class="colors_picker_color" style="background-color: ${state.colorRoof}"></div>
            <div class="colors_picker_button" id="louvre-color-picker-btn">Color Picker</div>
            <div id="louvre-color-picker-container"></div>
          </div>
        </div>
      </div>
    </form>
  `);

      const louvreColorSwitch = louvreColorContent.find(`.type_interface_post-size`);
      const louvreStandartColor = louvreColorContent.find("#standart-color");
      const louvreTexuredColor = louvreColorContent.find("#textured-color");
      const louvreActiveColorClass = "type_interface_colors-buttons_item--active";
      const louvreActiveColorTypeClass = "type_interface_post-size_item--active";

      // INIT INPUT
      louvreColorContent
        .find(".type_interface_colors-buttons_option")
        .each(function () {
          const $this = $(this);
          const $item = $this.closest(".type_interface_colors-buttons_item");
          const $imgContainer = $item.find(".image-container");

          const bgColor = $imgContainer.css("background-color");
          const bgImage = $imgContainer.css("background-image");
          const nameOfColor = $this.val();

          const extractPublicPath = (url) => {
            const match = url.match(/\/public\/.+$/);
            return match ? match[0] : url;
          };

          const backgroundColor = (() => {
            const match = bgImage.match(/url\(["']?(.*?)["']?\)/);
            if (bgImage && bgImage !== "none" && match && match[1]) {
              return "/" + match[1].trim().replace(/^\/+/, "");
            } else {
              return pergola.rgbToHex(bgColor);
            }
          })();

          const normalizedStateColor = extractPublicPath(state.colorRoof);

          if (
            normalizedStateColor.toLowerCase() === backgroundColor.toLowerCase()
          ) {
            $item.addClass(louvreActiveColorClass);
            $this.prop("checked", true);
            stringNameRoofColor = nameOfColor;

            setTimeout(() => {
              $this
                .closest(".interface__group")
                .find(".interface__group__head__param")
                .text(nameOfColor);
            }, 400);
          }
        });

      // HANDLE INPUTS
      louvreColorContent
        .find(".type_interface_colors-buttons_option")
        .on("change", function () {
          const $this = $(this);
          const $item = $this.closest(".type_interface_colors-buttons_item");
          const $imgContainer = $item.find(".image-container");

          const bgColor = $imgContainer.css("background-color");
          const bgImage = $imgContainer.css("background-image");

          let backgroundColor;
          const match = bgImage.match(/url\(["']?(.*?)["']?\)/);

          if (bgImage !== "none" && match && match[1]) {
            backgroundColor = match[1];
          } else {
            backgroundColor = pergola.rgbToHex(bgColor);
          }

          state.colorRoof = backgroundColor;

          const nameOfColor = $this.val();
          stringNameRoofColor = nameOfColor;

          $item.addClass(louvreActiveColorClass);
          $this
            .closest(".type_interface_colors-buttons")
            .find(".type_interface_colors-buttons_item")
            .not($item)
            .removeClass(louvreActiveColorClass);
          $this
            .closest(".interface__group")
            .find(".interface__group__head__param")
            .text(nameOfColor);

          applyAllColors();
          pergola.update();
        });

      // HANDLE COLOR PICKER
      let louvrePicker;
      louvreColorContent.find("#louvre-color-picker-btn").on("click", function () {
        const $group = $(this).closest(".interface__group");

        if (!louvrePicker) {
          const container = louvreColorContent.find("#louvre-color-picker-container")[0];
          if (!container) return;

          louvrePicker = Pickr.create({
            el: container,
            theme: "classic",
            default: state.colorRoof,
            components: {
              preview: false,
              opacity: false,
              hue: true,
              interaction: {
                hex: true,
                rgba: false,
                input: true,
                clear: false,
                save: true,
              },
            },
          });

          louvrePicker.on("change", (color) => {
            const selectedColor = color.toHEXA().toString().substring(0, 7);
            state.colorRoof = selectedColor;
            stringNameRoofColor = selectedColor;

            $group
              .find(".interface__group__head__param")
              .text(selectedColor);

            louvreColorContent
              .find("#color-box")
              .css("background-color", selectedColor);

            louvreColorContent
              .find(".type_interface_colors-buttons_item")
              .removeClass(louvreActiveColorClass);
            louvreColorContent
              .find(".type_interface_colors-buttons_option")
              .prop("checked", false);

            applyAllColors();
            pergola.updateLogos();
            pergola.update();
          });
        }
        louvrePicker.show();
      });

      // COLOR TYPE SWITCH
      louvreColorSwitch.find('input[type="radio"]').each(function () {
        const $input = $(this);
        const id = +$input.attr("id");

        $(this).removeClass(louvreActiveColorTypeClass);

        if (state.roofColorType === id) {
          $(this).parent().addClass(louvreActiveColorTypeClass);
        }

        if (!state.roofColorType) {
          louvreStandartColor.show();
          louvreTexuredColor.hide();
        } else {
          louvreTexuredColor.show();
          louvreStandartColor.hide();
        }

        $(this)
          .parent()
          .on("click", function () {
            const id = +$(this).find('input[type="radio"]').attr("id");
            state.roofColorType = id;

            louvreColorSwitch.find('input[type="radio"]').each(function () {
              $(this).parent().removeClass(louvreActiveColorTypeClass);
            });

            louvreColorContent.find(".colors_container");
            $(this).addClass(louvreActiveColorTypeClass);

            louvreStandartColor.hide();
            louvreTexuredColor.hide();

            if (!state.roofColorType) {
              louvreStandartColor.show();
              louvreTexuredColor.hide();
            } else {
              louvreTexuredColor.show();
              louvreStandartColor.hide();
            }
          });
      });

      return louvreColorContent;

    case typesInputs.electronic:
      const electronicContent = $(`
        <form class="type_interface_electronic">
          <div class="type_interface_electronic_item option" id="${pergolaConst.option.LEDRampLight}">
            <label class="type_interface_electronic_label">
              <div class="image-container">
                <img src="public/img/ledLight.png" alt="${pergolaConst.optionNameString.LEDRampLight}" class="color-image">
              </div>
              <span class="electronic-name">${pergolaConst.optionNameString.LEDRampLight}</span>
              <input class="type_interface_electronic_option" type="radio" name="electro_option" value="${pergolaConst.optionNameString.LEDRampLight}">
            </label>
          </div>

          <div class="type_interface_electronic_item option">
            <label class="type_interface_electronic_label">
              <div class="image-container">
                <img src="public/img/icon-heater.png" alt="Heaters" class="color-image">
              </div>
              <span class="electronic-name">Heater</span>
              <input class="type_interface_electronic_option" type="radio" name="electro_option" value="Heater">
            </label>
          </div>
        </form>
      `);

      const activeStyleElectro = "type_interface_electronic_item--active";

      //#region INIT INPUT
      electronicContent.find('input[type="radio"]').each(function () {
        const $input = $(this);
        const inputValue = $input.val();
        if (state.electro.has(inputValue)) {
          $input.prop("checked", true);
          $input.closest(".type_interface_electronic_item").addClass(activeStyleElectro);

          if (inputValue === "Heater") {
            state.heaters = true;
            updateHeaterVisibility(true);
          }
          if (inputValue === pergolaConst.optionNameString.LEDRampLight) {
            state.lightingEnabled = true;
          }
        }
        updateTextParam(state, this, true);
      });
      //#endregion

      //#region HANDLE INPUTS
      electronicContent.find('input[type="radio"]').on("click", function () {
        const $input = $(this);
        const inputValue = $input.val();

        if (state.electro.has(inputValue)) {
          // Deactivate
          state.electro.delete(inputValue);
          $input.prop("checked", false);
          $input.closest(".type_interface_electronic_item").removeClass(activeStyleElectro);

          if (inputValue === "Heater") {
            state.heaters = false;
            updateHeaterVisibility(false);
          }
          if (inputValue === pergolaConst.optionNameString.LEDRampLight) {
            state.lightingEnabled = false;
          }
        } else {
          // Activate
          state.electro.add(inputValue);
          $input.prop("checked", true);
          $input.closest(".type_interface_electronic_item").addClass(activeStyleElectro);

          if (inputValue === "Heater") {
            state.heaters = true;
            updateHeaterVisibility(true);
          }
          if (inputValue === pergolaConst.optionNameString.LEDRampLight) {
            state.lightingEnabled = true;
          }
        }

        updateTextParam(state, this, true);
        pergola.update();
      });
      //#endregion

      return electronicContent;
    //#endregion

    //#region ============ EXTRA OPTIONS (Privacy Wall, Auto Shade) ============
    case typesInputs.subSystem:
      const subSystemContent = $(`
        <form class="type_interface_electronic" id="last-group">

         <div class="type_interface_electronic_item option" id="${pergolaConst.systemType.slidingGlassDoor}">
            <label class="type_interface_electronic_label">
              <div class="image-container">
                <img src="public/img/marevo-menu-door-sliding-glass.png" alt="${pergolaConst.systemNameString.slidingGlassDoor}" class="color-image">
              </div>
              <span class="electronic-name">${pergolaConst.systemNameString.slidingGlassDoor}</span>
              <input class="type_interface_electronic_option" type="radio" name="subsystem_option" value="${pergolaConst.systemNameString.slidingGlassDoor}">
            </label>
          </div>

          <div class="type_interface_electronic_item option" id="${pergolaConst.systemType.privacyWall}">
            <label class="type_interface_electronic_label">
              <div class="image-container">
                <img src="public/img/marevo-menu-aluminium-shutters-sliding.png" alt="${pergolaConst.systemNameString.privacyWall}" class="color-image">
              </div>
              <span class="electronic-name">${pergolaConst.systemNameString.privacyWall}</span>
              <input class="type_interface_electronic_option" type="radio" name="subsystem_option" value="${pergolaConst.systemNameString.privacyWall}">
            </label>
          </div>

          <div class="type_interface_electronic_item option" id="${pergolaConst.systemType.autoShade}">
            <label class="type_interface_electronic_label">
              <div class="image-container">
                <img src="public/img/marevo-menu-blinds.png" alt="${pergolaConst.systemNameString.autoShade}" class="color-image">
              </div>
              <span class="electronic-name">${pergolaConst.systemNameString.autoShade}</span>
              <input class="type_interface_electronic_option" type="radio" name="subsystem_option" value="${pergolaConst.systemNameString.autoShade}">
            </label>
          </div>
        </form>
      `);

      const activeStyleSubSystem = "type_interface_electronic_item--active";

      function handleSubSystemInputChange($input, init = false) {
        const inputValue = $input.val();

        switch (inputValue) {
          case pergolaConst.systemNameString.slidingGlassDoor:
            state.currentActiveSystems = pergolaConst.systemType.slidingGlassDoor;
            break;
          case pergolaConst.systemNameString.autoShade:
            state.currentActiveSystems = pergolaConst.systemType.autoShade;
            break;
          case pergolaConst.systemNameString.privacyWall:
            state.currentActiveSystems = pergolaConst.systemType.privacyWall;
            break;
          default:
            break;
        }

        if (state.subSystem.has(inputValue) && !init) {
          state.subSystem.delete(inputValue);
          $input.prop("checked", false);
          $input.closest(".type_interface_electronic_item").removeClass(activeStyleSubSystem);

          pergola.removeSystemFromSpanType(state.currentActiveSystems);
          removeFromUrlSystemByType(state.currentActiveSystems);
          hideIcon(state.currentActiveSystems);

          state.currentActiveSystems = null;
        } else {
          // checking
          state.subSystem.add(inputValue);
          $input.prop("checked", true);
          $input.closest(".type_interface_electronic_item").addClass(activeStyleSubSystem);

          showIcon(state.currentActiveSystems);
        }

        pergola.update();

        $input
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${updateTextParam(state, $input[0], false, true, true)}`);
      }

      //#region INIT INPUT
      subSystemContent.find('input[type="radio"]').each(function () {
        const $input = $(this);
        const inputValue = $input.val();

        if (state.subSystem.has(inputValue)) {
          handleSubSystemInputChange($input, true);
        }
      });
      //#endregion

      //#region HANDLE INPUTS
      subSystemContent.find('input[type="radio"]').on("click", function () {
        handleSubSystemInputChange($(this));
      });
      //#endregion

      return subSystemContent;
    //#endregion

    case typesInputs.roofForLite:
      const roofContent = $(`
                <form class="type_interface_electronic">
                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="public/img/sletted.png" alt="Screens" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Slatted</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Slatted">
                    </label>
                  </div>

                  <div class="type_interface_electronic_item option">
                    <label class="type_interface_electronic_label">
                       <div class="image-container">
                           <img src="public/img/screen-roof.png" alt="Textured Black" class="color-image">
                       </div>
                       
                       <span class="electronic-name">Screens</span>
                       <input class="type_interface_electronic_option" type="radio" id="TexturedBlack" name="fav_language" value="Screens">
                    </label>
                  </div>
                </form>
                `);

      const activeStyleRoof = "type_interface_electronic_item--active";

      // INIT INPUT
      roofContent.find('input[type="radio"]').each(function () {
        const inputValue = $(this).val();

        if (state.moodLight === inputValue) {
          $(this)
            .closest(".type_interface_electronic_item")
            .addClass(activeStyleRoof);
          $(this).prop("checked", true);
        }
      });

      // HANDLE INPUTS
      roofContent.find('input[type="radio"]').on("click", function () {
        const inputValue = $(this).val();
        state.moodLight = inputValue;

        // CURRENT OPTION
        $(this).prop("checked", true);
        $(this)
          .closest(".type_interface_electronic_item")
          .addClass(activeStyleRoof);

        // ALL OPTION
        $(this)
          .closest(".type_interface_electronic")
          .find(".type_interface_electronic_item")
          .not($(this).closest(".type_interface_electronic_item"))
          .removeClass(activeStyleRoof);

        // UPDATE TEXT
        $(this)
          .closest(".interface__group")
          .find(".interface__group__head__param")
          .text(`${state.moodLight}`);

        pergola.update();
      });

      //#region SCREEN BUTTON HANDLE
      roofContent
        .find(".type_interface_electronic_item")
        .eq(1)
        .on("click", () => {
          const roofTypes = $(".interface__group").eq(3);

          roofTypes.show();
          pergola.update();
        });
      //#endregion

      //#region SLATTED HANDLE
      roofContent
        .find(".type_interface_electronic_item")
        .eq(0)
        .on("click", () => {
          const roofTypes = $(".interface__group").eq(3);

          roofTypes.hide();
          pergola.update();
        });
      //#endregion

      return roofContent;

    default:
      return `< div > NON HTML</div > `;
  }
}